import { CsValidatorRegistry } from './cs-validator-registry';


export class DefaultCsValidatorRegistry extends CsValidatorRegistry {
  constructor() {
    super();

  }
}
